export function filterCaseInsensitive(filter: any, row: any) {
    const id = filter.pivotId || filter.id;
    if (row[id] != null) {
        return String(row[id].toLowerCase()).includes(filter.value.toLowerCase());
    } else {
        return true;
    }
}